export default {
  "pl": {
    "inspiration_list": {
      "actions": {
        "cancel": "Cofnij",
        "delete": "Usuń",
        "deleteMultiple": "Usuń…",
        "delete_cancel": "Anuluj",
        "edit": "Edytuj",
        "new": "Nowy album z inspiracjami",
        "save": "Zapisz",
        "submit": "Prześlij",
        "tickBoxesDeletion": "Zaznacz pola wyboru przy plikach, które chcesz usunąć."
      },
      "attributes": {
        "name": "Nazwa"
      },
      "info": "Jak sobie wyobrażasz swój nowy dom? Prześlij zdjęcia, które cię inspirują! Dzięki albumom możesz umieszczać fotografie w różnych kategoriach takich jak kuchnia, łazienka czy meble.",
      "labels": {
        "inspiration_list": "Listy inspiracji",
        "inspirationlist": "Album z inspiracjami",
        "inspirations": "Inspiracje",
        "noInspirationLists": "Nie masz jeszcze żadnej listy inspiracji",
        "noInspirations": "Nie masz jeszcze żadnej inspiracji"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Twórz odrębne albumy dla różnych kategorii i umieszczaj w nich inspirujące zdjęcia kuchni, łazienek lub mebli.",
            "title": "Jak ozdobisz swój nowy dom?"
          }
        }
      },
      "validation": {
        "needTitle": "Należy podać tytuł",
        "selectInspirationList": "Wybierz przynajmniej 1 listę inspiracji"
      }
    }
  }
}
